import { useArtifactStudioContext } from '../../contexts/artifactStudio.context';
import { DiagramEditorProvider } from '../../contexts/DiagramEditor.provider';
import { DiagramEditorModal } from './DiagramEditorModal';

/** Keeps the new diagram's chat mounted when the backend creates its artifact. */
const NEW_DIAGRAM_KEY = 'new-diagram';

/** Mounts the diagram editor and its providers while the editor trowser is open. */
export function DiagramEditorTrowserMount() {
  const {
    householdId,
    isEditorOpen,
    editorArtifactID,
    newDiagram,
    showCreatedArtifact,
    closeEditor,
  } = useArtifactStudioContext();

  if (!isEditorOpen) return null;

  return (
    <DiagramEditorProvider
      key={newDiagram ? NEW_DIAGRAM_KEY : (editorArtifactID ?? undefined)}
      householdId={householdId}
      artifactID={editorArtifactID}
      onClose={closeEditor}
    >
      <DiagramEditorModal
        newDiagram={newDiagram}
        onArtifactCreated={showCreatedArtifact}
      />
    </DiagramEditorProvider>
  );
}
